import { Contact } from '../../features/contacts/contact.model';
import { Company } from '../../features/companies/company.model';
import { EventBB } from '../../features/events/event.model';
import { Project } from '../../features/projects/project.model';
import { Purchase } from '../../features/projects/purchase.model';
import { Payment } from '../payments/payment.model';
import { Task } from '../tasks/task.model';

export class Attachment {

    _id?: string;
    name?: string;
    key?: string;
    location?: string;

    contacts: Contact[] = [];
    payment: Payment;
    companies: Company[] = [];
    projects: Project[] = [];
    purchases: Purchase[] = [];
    events: EventBB[] = [];
    tasks: Task[] = [];

    createdBy?: string;
    modifiedBy?: string;
    createdAt?: Date;
    modifiedAt?: Date;

}





// WEBPACK FOOTER //
// ./client/app/shared/attachments/attachment.model.ts